var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponent511(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_51_1",
    "data-name": "Component 51 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(12.086 12.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M48.545,36.551v7.941h-4.6V37.083c0-1.86-.665-3.131-2.332-3.131a2.518,2.518,0,0,0-2.362,1.684,3.151,3.151,0,0,0-.152,1.122v7.734h-4.6s.062-12.549,0-13.848h4.6v1.962c-.009.015-.022.031-.031.045H39.1v-.045a4.572,4.572,0,0,1,4.15-2.287c3.029,0,5.3,1.979,5.3,6.232ZM29.673,23.969a2.4,2.4,0,1,0-.06,4.785h.03a2.4,2.4,0,1,0,.031-4.785ZM27.342,44.492h4.6V30.644h-4.6Z",
    transform: "translate(-27.068 -23.969)",
    fill: "#003a6f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent511);
export default __webpack_public_path__ + "static/media/Component 51 – 1.e256c3dc5d9d97bba132d61488ac0497.svg";
export { ForwardRef as ReactComponent };